'use strict';Object.defineProperty(exports, "__esModule", { value: true });
var languages = exports.languages = [
'en',
'cs',
'es',
'zh',
'ru',
'pt',
'fr',
'fi',
'de',
'ko',
'ja',
'ar'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy91dGlsL2xvY2FsZS5qcyJdLCJuYW1lcyI6WyJsYW5ndWFnZXMiXSwibWFwcGluZ3MiOiI7QUFDTyxJQUFNQSxnQ0FBWTtBQUNyQixJQURxQjtBQUVyQixJQUZxQjtBQUdyQixJQUhxQjtBQUlyQixJQUpxQjtBQUtyQixJQUxxQjtBQU1yQixJQU5xQjtBQU9yQixJQVBxQjtBQVFyQixJQVJxQjtBQVNyQixJQVRxQjtBQVVyQixJQVZxQjtBQVdyQixJQVhxQjtBQVlyQixJQVpxQixDQUFsQiIsImZpbGUiOiJsb2NhbGUuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbIlxuZXhwb3J0IGNvbnN0IGxhbmd1YWdlcyA9IFtcbiAgICAnZW4nLCBcbiAgICAnY3MnLCBcbiAgICAnZXMnLCBcbiAgICAnemgnLCBcbiAgICAncnUnLCBcbiAgICAncHQnLCBcbiAgICAnZnInLCBcbiAgICAnZmknLCBcbiAgICAnZGUnLCBcbiAgICAna28nLCBcbiAgICAnamEnLFxuICAgICdhcidcbl0iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/util/locale.js
// module id = g3dF
// module chunks = 7